<template>
    <div>
        <!-- Modal -->
        <div
            class="modal fade"
            :class="{ show: isVisible, 'd-block': isVisible }"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ 'Some Drivers aren\'t mapped to a company.' }}</h5>
                        <button
                            type="button"
                            class="close"
                            @click="closeModal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!errorMessage">
                            <div><b>Not mapped drivers:</b></div>
                            <div v-for="driver in notMappedDrivers">{{ driver.name }}</div>
                            <br>
                            <div>
                                Please go to the <a :href="siteUrl" target="_blank">{{ siteUrl }}</a>
                                page and add drivers to a company.
                            </div>
                        </div>
                        <div v-else class="text-danger">{{ errorMessage }}</div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="closeModal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Backdrop -->
        <div
            v-if="isVisible"
            class="modal-backdrop fade show"
        ></div>
    </div>
</template>

<script>

export default {
    name: "DriverMappingPopUp",
    props: {
    },
    data() {
        return {
            isVisible: false,
            notMappedDrivers: [],
            siteUrl: window.location.origin + '/drivers-and-companies',
            errorMessage: ''
        }
    },
    methods: {
        checkDriversMapping() {
            this.errorMessage = '';
            axios.get(`/check-drivers-mapping`)
                .then((response) => {
                    console.log(response.data);
                    if (response.data.notMappedDrivers.length) {
                        this.notMappedDrivers = response.data.notMappedDrivers;
                        this.openModal();
                    }
                }).catch((e) => {
                    console.error(e.response.data.message);
                    this.errorMessage = e.response.data.message || 'Error';
                    this.openModal();
            })
        },
        closeModal() {
            this.isVisible = false;
        },
        openModal() {
            this.isVisible = true;
        }
    },
    created() {
        this.checkDriversMapping();
    }
}
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}
.modal-dialog {
    height: 95%;
}
.modal-content {
    max-height: 100%;
}
.modal-body {
    overflow-y: scroll;
}

</style>
